"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduledTime1 = exports.planTeamSupport = exports.planIntentionStatement = exports.planGrowingEdge = exports.topic = exports.description = exports.category = exports.resource = exports.containedInPlace = exports.accommodation = exports.ownership = exports.url = exports.name = exports.report = exports.completedBefore = exports.reportingForm = exports.steps = exports.applicableTo = exports.accountingGroup = exports.material = exports.estimatedCo2Reduction = exports.estimatedCost = exports.timeDescription = exports.cycleSetTime = exports.cycleDuration = exports.priority = exports.estimatedTimeMax = exports.estimatedTimeMin = exports.actionTemplate = exports.exampleProperty = exports.EventTeam = exports.GameAction = exports.ThirdLevelAdministrativeArea = exports.SecondLevelAdministrativeArea = exports.FirstLevelAdministrativeArea = exports.Neighbourhood = exports.Block = exports.Household = exports.StepSet = exports.Resource = exports.Topic = exports.ActionTemplate = exports.PeaceGameDebrief = exports.ActionDebrief = exports.Action = exports.Report = exports.ExampleClass = exports._self = exports.ns = exports.loadData = void 0;
exports.faithDebrief5 = exports.faithDebrief4 = exports.faithDebrief3 = exports.faithDebrief2 = exports.faithDebrief1 = exports.loveDebrief1 = exports.abundanceDebrief1 = exports.cooperationDebrief1 = exports.unityDebrief1 = exports.onenessDebrief1 = exports.empowermentDebrief1 = exports.isCustom = exports.isBonus = exports.withoutAuthentication = exports.team = exports.currentTeam = exports.meetingType = exports.meetinSchedule = exports.Meeting = exports.teamLeader = exports.bronzeTemplate = exports.silverTemplate = exports.goldTemplate = exports.intendedMedal = exports.cardTitle = exports.debriefactionsTaken = exports.debriefplanGrowingEdge = exports.ActionPlan = exports.disabled = exports.goldMinScore = exports.silverMinScore = exports.bronzeMinScore = exports.OnceScoreAlgorithm = exports.ThresholdScoreAlgorithm = exports.scoreConfiguration = exports.ScoreConfiguration = exports.points = exports.score = exports.medal = exports.TopicScore = exports.quantity = exports.nextMeetingDate = exports.teamLeaderMessage = exports.debriefProblems = exports.debriefLearnings = exports.debriefDescription = exports.scheduledTime5 = exports.scheduledTime4 = exports.scheduledTime3 = exports.scheduledTime2 = void 0;
exports.irlcg = exports.hasImage = exports.attendance = exports.endDate = exports.startDate = exports.faithDebrief6 = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
//import all the exports of this file as one variable called _this (we need this at the end)
const _this = __importStar(require("./irlcg"));
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
var loadData = () => {
    return Promise.resolve().then(() => __importStar(require('../data/irlcg.json'))).then((data) => JSONLD_1.JSONLD.parse(data));
};
exports.loadData = loadData;
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
exports.ns = (0, NameSpace_1.createNameSpace)('http://lincd.org/ont/irlcg/');
/**
 * The NamedNode of the ontology itself
 */
exports._self = (0, exports.ns)('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
//Classes
exports.ExampleClass = (0, exports.ns)('ExampleClass');
exports.Report = (0, exports.ns)('Report');
exports.Action = (0, exports.ns)('Action');
exports.ActionDebrief = (0, exports.ns)('ActionDebrief');
exports.PeaceGameDebrief = (0, exports.ns)('PeaceGameDebrief');
exports.ActionTemplate = (0, exports.ns)('ActionTemplate');
exports.Topic = (0, exports.ns)('Topic');
exports.Resource = (0, exports.ns)('Resource');
exports.StepSet = (0, exports.ns)('StepSet');
exports.Household = (0, exports.ns)('Household');
exports.Block = (0, exports.ns)('Block');
exports.Neighbourhood = (0, exports.ns)('Neighbourhood');
exports.FirstLevelAdministrativeArea = (0, exports.ns)('FirstLevelAdministrativeArea');
exports.SecondLevelAdministrativeArea = (0, exports.ns)('SecondLevelAdministrativeArea');
exports.ThirdLevelAdministrativeArea = (0, exports.ns)('ThirdLevelAdministrativeArea');
exports.GameAction = (0, exports.ns)('GameAction');
exports.EventTeam = (0, exports.ns)('EventTeam');
//Properties
exports.exampleProperty = (0, exports.ns)('exampleProperty');
exports.actionTemplate = (0, exports.ns)('actionTemplate');
exports.estimatedTimeMin = (0, exports.ns)('estimatedTimeMin');
exports.estimatedTimeMax = (0, exports.ns)('estimatedTimeMax');
exports.priority = (0, exports.ns)('priority');
exports.cycleDuration = (0, exports.ns)('cycleDuration');
exports.cycleSetTime = (0, exports.ns)('cycleSetTime');
exports.timeDescription = (0, exports.ns)('timeDescription');
exports.estimatedCost = (0, exports.ns)('estimatedCost');
exports.estimatedCo2Reduction = (0, exports.ns)('estimatedCo2Reduction');
exports.material = (0, exports.ns)('material');
exports.accountingGroup = (0, exports.ns)('accountingGroup');
exports.applicableTo = (0, exports.ns)('applicableTo');
exports.steps = (0, exports.ns)('steps');
exports.reportingForm = (0, exports.ns)('reportingForm');
exports.completedBefore = (0, exports.ns)('completedBefore');
exports.report = (0, exports.ns)('report');
exports.name = (0, exports.ns)('name');
exports.url = (0, exports.ns)('url');
exports.ownership = (0, exports.ns)('ownership');
exports.accommodation = (0, exports.ns)('accommodation');
exports.containedInPlace = (0, exports.ns)('containedInPlace');
exports.resource = (0, exports.ns)('resource');
exports.category = (0, exports.ns)('category');
exports.description = (0, exports.ns)('description');
exports.topic = (0, exports.ns)('topic');
exports.planGrowingEdge = (0, exports.ns)('planGrowingEdge');
exports.planIntentionStatement = (0, exports.ns)('planIntentionStatement');
exports.planTeamSupport = (0, exports.ns)('planTeamSupport');
exports.scheduledTime1 = (0, exports.ns)('scheduledTime1');
exports.scheduledTime2 = (0, exports.ns)('scheduledTime2');
exports.scheduledTime3 = (0, exports.ns)('scheduledTime3');
exports.scheduledTime4 = (0, exports.ns)('scheduledTime4');
exports.scheduledTime5 = (0, exports.ns)('scheduledTime5');
exports.debriefDescription = (0, exports.ns)('debriefDescription');
exports.debriefLearnings = (0, exports.ns)('debriefLearnings');
exports.debriefProblems = (0, exports.ns)('debriefProblems');
exports.teamLeaderMessage = (0, exports.ns)('teamLeaderMessage');
exports.nextMeetingDate = (0, exports.ns)('nextMeetingDate');
exports.quantity = (0, exports.ns)('quantity');
exports.TopicScore = (0, exports.ns)('TopicScore');
exports.medal = (0, exports.ns)('medal');
exports.score = (0, exports.ns)('score');
exports.points = (0, exports.ns)('points');
exports.ScoreConfiguration = (0, exports.ns)('ScoreConfiguration');
exports.scoreConfiguration = (0, exports.ns)('scoreConfiguration');
exports.ThresholdScoreAlgorithm = (0, exports.ns)('ThresholdScoreAlgorithm');
exports.OnceScoreAlgorithm = (0, exports.ns)('OnceScoreAlgorithm');
exports.bronzeMinScore = (0, exports.ns)('bronzeMinScore');
exports.silverMinScore = (0, exports.ns)('silverMinScore');
exports.goldMinScore = (0, exports.ns)('goldMinScore');
exports.disabled = (0, exports.ns)('disabled');
exports.ActionPlan = (0, exports.ns)('ActionPlan');
exports.debriefplanGrowingEdge = (0, exports.ns)('debriefplanGrowingEdge');
exports.debriefactionsTaken = (0, exports.ns)('debriefactionsTaken');
exports.cardTitle = (0, exports.ns)('cardTitle');
exports.intendedMedal = (0, exports.ns)('intendedMedal');
exports.goldTemplate = (0, exports.ns)('goldTemplate');
exports.silverTemplate = (0, exports.ns)('silverTemplate');
exports.bronzeTemplate = (0, exports.ns)('bronzeTemplate');
exports.teamLeader = (0, exports.ns)('teamLeader');
exports.Meeting = (0, exports.ns)('Meeting');
exports.meetinSchedule = (0, exports.ns)('meetingSchedule');
exports.meetingType = (0, exports.ns)('meetingType');
exports.currentTeam = (0, exports.ns)('currentTeam');
exports.team = (0, exports.ns)('team');
exports.withoutAuthentication = (0, exports.ns)('withoutAuthentication');
exports.isBonus = (0, exports.ns)('isBonus');
exports.isCustom = (0, exports.ns)('isCustom');
exports.empowermentDebrief1 = (0, exports.ns)('empowermentDebrief1');
exports.onenessDebrief1 = (0, exports.ns)('onenessDebrief1');
exports.unityDebrief1 = (0, exports.ns)('unityDebrief1');
exports.cooperationDebrief1 = (0, exports.ns)('cooperationDebrief1');
exports.abundanceDebrief1 = (0, exports.ns)('abundanceDebrief1');
exports.loveDebrief1 = (0, exports.ns)('loveDebrief1');
exports.faithDebrief1 = (0, exports.ns)('faithDebrief1');
exports.faithDebrief2 = (0, exports.ns)('faithDebrief2');
exports.faithDebrief3 = (0, exports.ns)('faithDebrief3');
exports.faithDebrief4 = (0, exports.ns)('faithDebrief4');
exports.faithDebrief5 = (0, exports.ns)('faithDebrief5');
exports.faithDebrief6 = (0, exports.ns)('faithDebrief6');
exports.startDate = (0, exports.ns)('startDate');
exports.endDate = (0, exports.ns)('endDate');
exports.attendance = (0, exports.ns)('attendance');
exports.hasImage = (0, exports.ns)('hasImage');
//An extra grouping object so all the entities can be accessed from the prefix/name
exports.irlcg = {
    //Classes
    EventTeam: exports.EventTeam,
    Report: exports.Report,
    Action: exports.Action,
    ActionPlan: exports.ActionPlan,
    ActionDebrief: exports.ActionDebrief,
    PeaceGameDebrief: exports.PeaceGameDebrief,
    ActionTemplate: exports.ActionTemplate,
    meetinSchedule: exports.meetinSchedule,
    Meeting: exports.Meeting,
    actionTemplate: exports.actionTemplate,
    Topic: exports.Topic,
    Resource: exports.Resource,
    StepSet: exports.StepSet,
    Household: exports.Household,
    Block: exports.Block,
    Neighbourhood: exports.Neighbourhood,
    FirstLevelAdministrativeArea: exports.FirstLevelAdministrativeArea,
    SecondLevelAdministrativeArea: exports.SecondLevelAdministrativeArea,
    ThirdLevelAdministrativeArea: exports.ThirdLevelAdministrativeArea,
    GameAction: exports.GameAction,
    TopicScore: exports.TopicScore,
    //Properties
    bronzeMinScore: exports.bronzeMinScore,
    meetingType: exports.meetingType,
    silverMinScore: exports.silverMinScore,
    goldMinScore: exports.goldMinScore,
    medal: exports.medal,
    score: exports.score,
    scoreConfiguration: exports.scoreConfiguration,
    points: exports.points,
    goldTemplate: exports.goldTemplate,
    silverTemplate: exports.silverTemplate,
    bronzeTemplate: exports.bronzeTemplate,
    exampleProperty: exports.exampleProperty,
    estimatedTimeMin: exports.estimatedTimeMin,
    estimatedTimeMax: exports.estimatedTimeMax,
    priority: exports.priority,
    cycleDuration: exports.cycleDuration,
    cycleSetTime: exports.cycleSetTime,
    timeDescription: exports.timeDescription,
    estimatedCost: exports.estimatedCost,
    estimatedCo2Reduction: exports.estimatedCo2Reduction,
    material: exports.material,
    accountingGroup: exports.accountingGroup,
    applicableTo: exports.applicableTo,
    steps: exports.steps,
    reportingForm: exports.reportingForm,
    completedBefore: exports.completedBefore,
    report: exports.report,
    intendedMedal: exports.intendedMedal,
    name: exports.name,
    url: exports.url,
    ownership: exports.ownership,
    accommodation: exports.accommodation,
    containedInPlace: exports.containedInPlace,
    resource: exports.resource,
    category: exports.category,
    cardTitle: exports.cardTitle,
    description: exports.description,
    topic: exports.topic,
    planGrowingEdge: exports.planGrowingEdge,
    planIntentionStatement: exports.planIntentionStatement,
    planTeamSupport: exports.planTeamSupport,
    ScoreConfiguration: exports.ScoreConfiguration,
    scheduledTime1: exports.scheduledTime1,
    scheduledTime2: exports.scheduledTime2,
    scheduledTime3: exports.scheduledTime3,
    scheduledTime4: exports.scheduledTime4,
    scheduledTime5: exports.scheduledTime5,
    startDate: exports.startDate,
    endDate: exports.endDate,
    debriefplanGrowingEdge: exports.debriefplanGrowingEdge,
    debriefactionsTaken: exports.debriefactionsTaken,
    debriefDescription: exports.debriefDescription,
    debriefLearnings: exports.debriefLearnings,
    debriefProblems: exports.debriefProblems,
    teamLeaderMessage: exports.teamLeaderMessage,
    teamLeader: exports.teamLeader,
    nextMeetingDate: exports.nextMeetingDate,
    quantity: exports.quantity,
    ThresholdScoreAlgorithm: exports.ThresholdScoreAlgorithm,
    OnceScoreAlgorithm: exports.OnceScoreAlgorithm,
    disabled: exports.disabled,
    isBonus: exports.isBonus,
    isCustom: exports.isCustom,
    currentTeam: exports.currentTeam,
    team: exports.team,
    withoutAuthentication: exports.withoutAuthentication,
    empowermentDebrief1: exports.empowermentDebrief1,
    onenessDebrief1: exports.onenessDebrief1,
    unityDebrief1: exports.unityDebrief1,
    cooperationDebrief1: exports.cooperationDebrief1,
    abundanceDebrief1: exports.abundanceDebrief1,
    loveDebrief1: exports.loveDebrief1,
    faithDebrief1: exports.faithDebrief1,
    faithDebrief2: exports.faithDebrief2,
    faithDebrief3: exports.faithDebrief3,
    faithDebrief4: exports.faithDebrief4,
    faithDebrief5: exports.faithDebrief5,
    faithDebrief6: exports.faithDebrief6,
    attendance: exports.attendance,
    hasImage: exports.hasImage,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
(0, package_1.linkedOntology)(_this, exports.ns, 'irlcg', exports.loadData, '../data/irlcg.json');
//# sourceMappingURL=irlcg.js.map